
const TableauSynthese = function(element, options) {
    this.element  = $(element);
    this.table    = this.element.find('table');
    this.body     = this.table.find('tbody');
    this.options  = options;

    // Gestion du filtrage
    this.defaut = this.options.defaut;
    this.filtre = $.extend({}, this.options.filtre);

    this.btnFiltre = $(this.options.button.filter);
    this.btnRefresh  = $(this.options.button.refresh);
    this.btnSemainePrev = $(this.options.button.semainePrev);
    this.btnSemaineNext = $(this.options.button.semaineNext);

    this.semaine = $(this.options.semaineCourante);

    this.btnFiltre.on('form-success.modal', $.proxy(this.onFiltreSuccess, this));
    this.btnSemainePrev.on('click', $.proxy(this.onSemainePrevClick, this));
    this.btnSemaineNext.on('click', $.proxy(this.onSemaineNextClick, this));
    this.btnRefresh.on('click', $.proxy(this.onRefreshClick, this));

    $(document).on('click', this.options.button.reset, $.proxy(this.onResetClick, this));

    // Mise à jour des informations du tableau (chargeur, zone et livreur)
    this.element.on('change', '[data-select-chargeur]', event => {
        this.updateChargeur($(event.currentTarget));
    });
    this.element.on('change', '[data-select-zone]', event => {
        this.updateZone($(event.currentTarget));
    });
    this.element.on('change', '[data-select-livreur]', event => {
        this.updateLivreur($(event.currentTarget));
    });

    // Refresh hauteur du tableau
    this.clone = this.table.clone();
    this.clone.find('tbody').remove();
    this.clone.addClass('table-fixed-header');
    this.clone.insertAfter(this.table);

    $(window).on('resize', $.proxy(this.refreshFixedHeader, this));
    $(window).on('scroll', $.proxy(this.fixHeader, this));
    this.refreshFixedHeader();
    this.fixHeader();

    // Hover
    this.body.on('mouseenter mouseover', 'tr', $.proxy(this.onMouseEnterRow, this));
    this.body.on('mouseleave',  $.proxy(this.onMouseLeave, this));
};

$.extend(TableauSynthese.prototype, {
    onMouseEnterRow: function(event) {
        var row = $(event.currentTarget);

        this.onMouseLeave();
        this.body.find('tr[data-commandes="' + row.attr('data-commandes') + '"]').addClass('hover');
    },

    onMouseLeave: function() {
        this.body.find('.hover').removeClass('hover');
    },

    refreshFixedHeader: function() {
        const headers = this.table.find('thead th'),
            clones = this.clone.find('thead th');

        headers.map((index, header) => {
            $(clones[index]).css('width', $(header).css('width'));
        });

        this.clone.css('width', this.table.css('width'));
    },

    fixHeader: function() {
        if ($(window).scrollTop() > 21) {
            // Show header fixed clone
            this.element.addClass('show-fixed-header');
        } else {
            this.element.removeClass('show-fixed-header');
        }
    },

    updateChargeur: function($target) {
        const commandes = $target.closest('[data-commandes]').attr('data-commandes');

        $.ajax({
            url: Routing.generate('tableau_synthese_chargeur'),
            method: 'post',
            data: {
                token: this.element.attr('data-token'),
                commandes: commandes.split(','),
                chargeur: $target.val()
            },
            success: response => {
                Notifications.messages(response.messages);
            }
        })
    },

    updateZone: function($target) {
        const commandes = $target.closest('[data-commandes]').attr('data-commandes');

        $.ajax({
            url: Routing.generate('tableau_synthese_zone'),
            method: 'post',
            data: {
                token: this.element.attr('data-token'),
                commandes: commandes.split(','),
                zone: $target.val()
            },
            success: response => {
                Notifications.messages(response.messages);
            }
        })
    },

    updateLivreur: function($target) {
        const ventes = $target.closest('[data-ventes]').attr('data-ventes');

        $.ajax({
            url: Routing.generate('tableau_synthese_livreur'),
            method: 'post',
            data: {
                token: this.element.attr('data-token'),
                ventes: ventes.split(','),
                livreur: $target.val()
            },
            success: response => {
                Notifications.messages(response.messages);
            }
        })
    },

    refreshSynthese: function() {
        this.semaine.text('S' + this.filtre.sdate);

        $.ajax({
            url: Routing.generate('tableau_synthese_tableau'),
            data: this.filtre,
            success: response => {
                this.body.html(response);
            }
        })
    },

    onRefreshClick: function(event) {
        event.preventDefault();

        this.refreshSynthese();
    },

    onResetClick: function(event) {
        this.filtre = $.extend({}, this.defaut);

        $.ajax({
            url: Routing.generate('tableau_logistique_reset'),
            success: () => {
                this.refreshSynthese();
            }
        });
    },

    onFiltreSuccess: function(event, response) {
        this.filtre = response;

        this.refreshSynthese();
    },

    onSemainePrevClick: function(event) {
        event.preventDefault();

        let date = moment(this.filtre.date, 'DD/MM/YYYY').subtract('1', 'weeks');

        this.refreshFiltre(date);
    },

    onSemaineNextClick: function(event) {
        event.preventDefault();

        let date = moment(this.filtre.date, 'DD/MM/YYYY').add('1', 'weeks');

        this.refreshFiltre(date);
    },

    refreshFiltre(date) {
        this.filtre.date = date.format('DD/MM/YYYY');
        this.filtre.sdate = date.format('WW');

        this.refreshSynthese();
    }
});

$.fn.tableauSynthese = function(options) {
    return $.each(this, function () {
        new TableauSynthese(this, options);
    })
};


// WEBPACK FOOTER //
// ./js/form/tableauSynthese.js